import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Route',
    entityNamePlural: 'Routes',
  }), [])
}
